module.exports = __webpack_public_path__ + "img/logo-signal-mono.6b25b1d4.svg";